import React, { useEffect, useState } from 'react'
import {
  PickingRouteStatusItem,
  ZoneStatusItem
} from '../../../interfaces/WorkOrder/WorkOrder'
import { ValidatedZones } from '../../CheckDispatch/screens/ValidatedZones'
import { useZones } from '../../../hooks'
import { State } from '../../_EOS/State'
import { Status } from '../../../hooks/useFetchState'
import {
  Box,
  Typography
} from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'

interface ValidationStatusPickingRoutesProps {
  pickingRouteStatus: PickingRouteStatusItem[] | undefined
}

export const ValidationStatusPickingRoutes: React.FC<ValidationStatusPickingRoutesProps> =
  ({ pickingRouteStatus }) => {
    const classes = useStyles()
    const [data, setData] = useState<ZoneStatusItem[]>([])

    const {
      zonesState: { zones },
      getZones
    } = useZones()

    useEffect(() => {
      if (zones?.length === 0) {
        getZones()
      }
    }, [])

    // obtener zonas
    // obtener zonas
    useEffect(() => {
      if (
        pickingRouteStatus !== undefined &&
        zones !== undefined &&
        zones.length > 0
      ) {
        const element: ZoneStatusItem[] | undefined = pickingRouteStatus?.map(
          (item) => ({
            zoneName:
              zones?.filter((zone) => zone.zoneId === item.zoneId)[0]
                .zoneName || 'Sin nombre de zona',
            isValidated: item.validationStatusId === 3
          })
        )
        setData(element || [])
      }
    }, [pickingRouteStatus, zones])

    return (
      <Box
        display={'flex'}
        alignContent={'center'}
        justifyContent={'center'}
        flexWrap={'wrap'}
      >
        <State
          state={{
            status: zones?.length === 0 ? Status.Loading : Status.Success
          }}
          loadingMessage='Obtiendo estado de rutas'
        >
          <Typography className={classes.dispatchValidationError}>
            Existen rutas de picking sin validar en las siguientes zonas
          </Typography>
          <ValidatedZones zonesStatus={data} />
        </State>
      </Box>
    )
  }

const useStyles = makeStyles(() =>
  createStyles({
    dispatchValidationError: {
      color: '#ED4337',
      textAlign: 'center',
      marginBottom: '15px'
    }
  })
)
